import type React from "react";
import { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export type DropdownMenuItemUIProps = {
  to?: string;
} & React.LiHTMLAttributes<HTMLLIElement>;

export const DropdownMenuItemUI: FC<DropdownMenuItemUIProps> = ({
  to,
  onClick,
  children,
}) => {
  const navigate = useNavigate();

  const onClickLinkHandler: React.MouseEventHandler<HTMLLIElement> =
    useCallback(
      event => {
        to && navigate(to);
        onClick?.(event);
      },
      [to, navigate, onClick],
    );

  return (
    <li
      className="hover:bg-gray-100 px-4 py-3 cursor-pointer text-gray-700 first:rounded-t-lg last:rounded-b-lg transition-colors duration-150"
      onClick={onClickLinkHandler}
    >
      {children}
    </li>
  );
};
